/* eslint-disable */
import React, { Fragment } from 'react'
import Logo from '../../components/Logo'

export default ({children}) => (
	<Fragment>
		<header id='home'>
			<div className="header__bg"></div>
			<div className="content-wrap">
				<Logo />
			</div>
			<div className="content-wrap">
				<h1>Finally—Your Facebook Advertising<br/>In The Context You Need</h1>
				<p className="subtext">Adscore is a fast, free way to compare your frequency, cost efficiency<br/> and more to best practices developed from over $4 billion of social advertising investments.</p>
			</div>
			<div className="content-wrap">
				<div className="progress-step-wrap home">
					<div className="progress-step short">
						<h2 className="step-number">1</h2>
						<p className="step-description">Type in your email address</p>
					</div>
					<div className="progress-step grey-out short">
						<h2 className="step-number">2</h2>
						<p className="step-description">Choose your ad account</p>
					</div>
					<div className="progress-step grey-out short">
						<h2 className="step-number">3</h2>
						<p className="step-description">Analyze your results</p>
					</div>
				</div>
			</div>
			<div className="content-wrap">
				{children}
			</div>
		</header>
		<footer>
			<a href="https://unified.com/privacy-policy">Privacy Policy</a><span>| ©2018 Unified Enterprise Corp.</span>
  	</footer>
	</Fragment>
)



// WEBPACK FOOTER //
// ./src/containers/HomeTopLeads/wrapper.js